import { routes } from "../Routes/RouteConstants";

export type FuelType = "gas" | "elec";

/**
 * Generate a URL for the public remove supply form with the fuel parameter
 * @param code - The account holder request code
 * @param fuel - The fuel type (gas or elec)
 * @returns The complete URL with fuel parameter
 */
export const getPublicRemoveSupplyUrl = (
  code: string,
  fuel: FuelType
): string => {
  const baseUrl = routes.publicRemoveSupply.replace(":code", code);
  return `${baseUrl}?fuel=${fuel}`;
};

/**
 * Generate a URL for the public remove supply success page with the fuel parameter
 * @param fuel - The fuel type (gas or elec)
 * @returns The complete URL with fuel parameter
 */
export const getPublicRemoveSupplySuccessUrl = (fuel: FuelType): string => {
  return `${routes.publicRemoveSupplySuccess}?fuel=${fuel}`;
};

/**
 * Extract fuel type from current URL search params
 * @param searchParams - URLSearchParams from useSearchParams hook
 * @returns The fuel type or 'elec' as default
 */
export const getFuelFromParams = (searchParams: URLSearchParams): FuelType => {
  const fuel = searchParams.get("fuel");
  return fuel === "gas" ? "gas" : "elec";
};
